<template>
  <div class="page page--home">
    <Seeds/>
  </div>
</template>

<script>
// @ is an alias to /src
import Seeds from '@/components/Seeds.vue'

export default {
  name: 'HomeView',
  components: {
    Seeds
  }
}
</script>
